import { toast } from "@assetwatch/ui";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

declare module "@tanstack/react-query" {
  interface Register {
    queryMeta: {
      errorMessage?: string;
    };
  }
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (_error, query) => {
      const { errorMessage } = query.meta ?? {};

      if (errorMessage) {
        toast.error(errorMessage, {
          icon: true,
          onDismiss: () => {},
        });
      }
    },
  }),
});

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: "intent",
  defaultPendingMs: 0,
  scrollRestoration: true,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
